import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "@app/config/app.config";
import { HeadersSetterHelper } from "@app/shared/helpers/http-headers-setter-helper";
import { ISpringResponseBody, observeTypes } from "@app/shared/interfaces/response-interfaces";
import { HandleError, HttpErrorHandler } from "@app/shared/services/http-error-handler.service";
import { Store } from "@ngrx/store";
import { catchError, map } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { ActivationStatusStep, SmartCardData } from "../activation.model";

@Injectable()
export class ActivationService {
    private handleError: HandleError;
    private headerHelper: HeadersSetterHelper;

    constructor(
        private httpErrorHandler: HttpErrorHandler,
        private http: HttpClient,
        private store: Store<any>,
    ) {
        this.handleError = httpErrorHandler.createHandleError('ActivationService');
        this.headerHelper = new HeadersSetterHelper(this.store);
    }

    generateOTP(requestId: string): Observable<any> {
        return this.http.post<ISpringResponseBody>(
            AppConfig.endpoints.activation.generateOTP, {}, this.headerHelper.otpOptions(observeTypes.BODY, requestId)
        ).pipe(
            catchError(this.handleError('generateOTP'))
            );
    }

    validateOTP(request:any): Observable<any> {
        return this.http.post<any>(
            AppConfig.endpoints.activation.validateOTP,
            {
                serviceRequestId: request.requestId,
                otpCode: request.code,
                cardSerialNumber: request.cardSerialNumber
            }
        ).pipe(
            catchError(this.handleError('validateOTP'))
            );
    }


    getSmartCardData(requestId: string): Observable<any> {

        return this.http.get<any>(
            AppConfig.endpoints.activation.getSmartCardData, this.headerHelper.bTrustRequestId(observeTypes.BODY,requestId)
        ).pipe(
            catchError(this.handleError('getSmartCardData'))
            );
    }

    getActivationData(uuid: string): Observable<any> {

        return this.http.get<any>(
            AppConfig.endpoints.activation.getActivationData.replace('{requestUUID}', `${uuid}`), this.headerHelper.getActivationData(observeTypes.BODY)
        ).pipe(
            catchError(this.handleError('getActivationData'))
            );
    }

    updateStatus(serviceRequestId: string, status: ActivationStatusStep) : Observable<ISpringResponseBody> {
        return this.http.put<ISpringResponseBody>(
            AppConfig.endpoints.activation.updateActivationStep,
            {
                serviceRequestId: serviceRequestId,
                newStatus: status
            }
        ).pipe(
            catchError(this.handleError('updateStatus')),
            map((res: ISpringResponseBody) => {
                return res;
            }));
    }

    getDocument(documentId: string): Observable<any> {
        return this.http.get(
          AppConfig.endpoints.activation.getDocument.replace('{documentId}', `${documentId}`),
          this.headerHelper.fileOptionsActivation(observeTypes.RESPONSE, 'blob')
        ).pipe(
          catchError(this.handleError('getFile'))
        );
      }
      getDocumentFull(documentId: string): Observable<any> {
        return this.http.get(
          AppConfig.endpoints.activation.getDocumentFull.replace('{documentId}', `${documentId}`),
          this.headerHelper.getActivationData(observeTypes.BODY)
        ).pipe(
          catchError(this.handleError('getFile'))
        );
      }

    activateCertificate(invoiceRequest, btrustRequestId, status):Observable<any> {
        return this.http.post<ISpringResponseBody>(
        AppConfig.endpoints.activation.finalizeCertificateActivation, {invoiceRequest, btrustRequestId, status}
        ).pipe(
            catchError(this.handleError('activateCertificate'))
        );
    }
    getIssuedCert(btrustRequestId):Observable<any> {
        return this.http.get<any>(
            AppConfig.endpoints.activation.getIssuedCert, this.headerHelper.otpOptions(observeTypes.BODY, btrustRequestId)
        ).pipe(
             catchError(this.handleError('getIssuedCert'))
        );
    }
    bissDigestDocuments(request: any) {
        return this.http.post<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.biss.bissDigest, request
            ).pipe(
                catchError(this.handleError('bissDigestDocuments'))
            );
    }
    composeDocuments(request: any) {
        return this.http.post<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.biss.bissCompose, request
            ).pipe(
                catchError(this.handleError('composeDocuments'))
            );
    }
    uploadSignedDocuments(request: any, btrustRequestId):Observable<any> {
        return this.http.post<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.uploadSignedDocuments, request, this.headerHelper.otpOptions(observeTypes.BODY, btrustRequestId)
            ).pipe(
                catchError(this.handleError('uploadSignedDocuments'))
            );
    }

    getBTrustEmailData(serviceReuestId) {
        return this.http.get<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.bTrustMailData, { "params": { "serviceRequestId": serviceReuestId } }
        ).pipe(
            catchError(this.handleError('getBTrustEmailData'))
        );
    }

    previewBtrustMailDocument(email, btrustRequestId): Observable<any> {
        return this.http.get<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.previewBtrustMailDocument, this.headerHelper.BTrustDocumentOptions(observeTypes.RESPONSE, { "email": email }, btrustRequestId, 'blob')
        ).pipe(
            catchError(this.handleError('previewBtrustMailDocument'))
        );
    }

    activateBTrustEmail(request: any ): Observable<any> {
        return this.http.post<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.activateBTrustEmail, request,this.headerHelper.postOptions(observeTypes.BODY)
        ).pipe(
            catchError(this.handleError('activateBTrustEmail'))
        );
    }

    getDownloadInfo(operatingSystem): Observable<any> {
        return this.http.get<ISpringResponseBody | any>(
            AppConfig.endpoints.activation.getDownloadInfo, { "params": { "operatingSystem": operatingSystem }}
        ).pipe(
            catchError(this.handleError('previewBtrustMailDocument'))
        );
    }
}